import { Autocomplete, AutocompleteProps, TextField, TextFieldProps } from '@mui/material';
import { debounce } from 'lodash';
import { useState } from 'react';
import PaperSelect from 'src/components/common/PaperSelect';
import { useQueryUsers } from 'src/services/queries';
import { getArrayDefault } from 'src/utils/helpers/arrayHelpers';

interface IProps extends Omit<
  AutocompleteProps<
    {
      uuid: string;
      email: string;
    },
    false,
    false,
    false
  >,
  'renderInput' | 'options'
> {
  inputProps?: TextFieldProps;
  selected?: string;
}

const FormItemUsers = (props: IProps) => {
  const [search, setSearch] = useState('' as string);
  const { data, isFetching } = useQueryUsers({
    offset: 0,
    limit: 10,
    status: ['activated'],
    search,
  });
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };
  const debounceSearch = debounce(handleSearch, 1000);
  return (
    <Autocomplete
      {...props}
      loading={isFetching}
      autoComplete
      fullWidth
      size="small"
      options={getArrayDefault(data?.data)}
      PaperComponent={PaperSelect}
      getOptionLabel={(o) => o.email}
      getOptionKey={(o) => o.uuid}
      renderInput={(params) => (
        <TextField
          {...params}
          onChange={debounceSearch}
          {...props.inputProps}
          placeholder={props.inputProps?.placeholder ?? 'Search user by email'}
          label={props.inputProps?.label ?? 'Select User'}
        />
      )}
    />
  );
};

export default FormItemUsers;
